// extracted by mini-css-extract-plugin
export default {"btn-block":"AppButton_btn-block__34viX","btn-large":"AppButton_btn-large__A9O73","btn-small":"AppButton_btn-small__2ZjQN"};